// Advisory next-action selector: never an approval, page-lock or publishing gate.
// Completed means the owner explicitly marked the manuscript as completed;
// Chapter count and provisional previews cannot confer that status.
export function novelNextActionJourneyV1({
  publicationStatus = "inDevelopment", chapterCount = 0, sceneCount = 0,
  journeyReadiness = {}, currentWorkspace = "overview",
  previewEnabled = false, previewBusy = false, finalApprovalEnabled = false,
} = {}) {
  const chapters = Number(chapterCount) || 0;
  const scenes = Number(sceneCount) || 0;
  if (chapters < 1) return "book-structure";
  if (scenes < 1) return "write";

  const status = String(publicationStatus || "").trim().toLowerCase();
  const markedCompleted = ["completed", "publishedamazon", "publishedexternal"].includes(status);
  if (!markedCompleted) return "write";

  // Fail closed if saved-source or format readiness is missing/unknown.
  if (journeyReadiness?.manuscriptReady !== true) return "book-structure";
  if (journeyReadiness?.formatReady !== true) return "setup";
  if (journeyReadiness?.readyToPreview !== true) return "publication-preparation";

  // These are contextual suggestions, NOT persisted "review done" milestones.
  if (currentWorkspace === "review") return "publication-preparation";
  if (currentWorkspace === "publication-preparation") return "publication-proof";
  if (currentWorkspace === "publication-proof") {
    return previewEnabled && !previewBusy ? "preview-book-interior" : "publication-preparation";
  }
  if (currentWorkspace === "preview-book-interior") {
    if (previewBusy) return "preview-book-interior";
    return finalApprovalEnabled ? "final-print-approval" : "publication-preparation";
  }
  return "review";
}
